import EstadoDeudaShow from './EstadoDeudaShow'
export {EstadoDeudaShow}
export default EstadoDeudaShow
